import React, { useState } from 'react';
import './SiteFooter.css';
import logoFooter from '../assets/logo-footer.png';

const SiteFooter = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({ client_name: '', client_phone: '' });
  const [status, setStatus] = useState(null);

  const handleOpenModal = () => {
    setIsModalOpen(true);
    setStatus(null); // Reset status when opening modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFormData({ client_name: '', client_phone: '' });
    setStatus(null);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('pending');
    console.log('Отправляем данные:', formData);

    try {
      const response = await fetch('/api/callback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          operator_name: 'Общий отдел (Сайт)',
          operator_phone: 'Основной номер',
        }),
      });

      if (!response.ok) throw new Error('Failed to submit callback request');
      const responseData = await response.json();
      setStatus('success');
      setFormData({ client_name: '', client_phone: '' });
      setIsModalOpen(false);
      console.log('Submission successful:', responseData);
    } catch (error) {
      setStatus('error');
      console.error('Submission error:', error);
    }
  };

  return (
    <>
      <footer className="site-footer">
        <div className="site-footer__inner">
          <h5 className='site-footer__logo'>ASIAN TOUR</h5>
          <nav className="site-footer__nav">
            <a href="/packages">Премиальные пакеты</a>
            <a href="/book">Бронируйте с нами</a>
            <a href="/self-booking">Сам бронирую</a>
            <a href="#call-me-back" onClick={(e) => { e.preventDefault(); handleOpenModal(); }}>Перезвоните мне</a>
            <a href="/why">Почему Asian Tour</a>
            <a href="/contact">Контакты</a>
          </nav>
        </div>
        <div className="site-footer__bottom">
          <p>© 2025 Все права защищены | AsianTour</p>
          <div className="policy-links">
            <a href="/">Сайт компании</a>
            <span>|</span>
            <a href="#privacy-policy">Политика конфиденциальности</a>
          </div>
        </div>
      </footer>

      {isModalOpen && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target.classList.contains('modal-overlay')) handleCloseModal();
          }}
        >
          <div className="modal-content">
            <h2>Мы вам перезвоним</h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="client_name"
                placeholder="Ваше имя"
                value={formData.client_name}
                onChange={handleChange}
                required
                style={{ width: '100%', padding: 12, borderRadius: 10, border: '1px solid #ddd', marginBottom: 10 }}
              />
              <input
                type="tel"
                name="client_phone"
                placeholder="Номер телефона"
                value={formData.client_phone}
                onChange={handleChange}
                required
                style={{ width: '100%', padding: 12, borderRadius: 10, border: '1px solid #ddd', marginBottom: 10 }}
              />
              <div className="modal-buttons">
                <button
                  type="submit"
                  className="submit-btn"
                  style={{
                    padding: '10px 20px',
                    borderRadius: 10,
                    border: 'none',
                    background: 'linear-gradient(135deg,#0d6efd,#6f42c1)',
                    color: '#fff',
                    cursor: 'pointer'
                  }}
                >
                  {status === 'pending' ? 'Отправляю...' : 'Отправить'}
                </button>
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={handleCloseModal}
                  style={{
                    padding: '10px 20px',
                    borderRadius: 10,
                    border: '1px solid #ddd',
                    background: '#fff',
                    cursor: 'pointer'
                  }}
                >
                  Закрыть
                </button>
              </div>
              {status === 'success' && (
                <div style={{ color: 'green', marginTop: 10 }}>Заявка отправлена. Мы свяжемся с вами.</div>
              )}
              {status === 'error' && (
                <div style={{ color: 'crimson', marginTop: 10 }}>Ошибка отправки. Попробуйте ещё раз.</div>
              )}
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default SiteFooter;






